module.exports = __webpack_public_path__ + "img/niger.d8f8d3a.webp";